import {Request} from "../request.abstract";
import {ImportsEndpoint} from "./imports/api.service";
import {Messagecentral} from "./api.models";
import {Observable} from "rxjs/Observable";
import {ProxyEndpoint} from './proxy/api.service';

export class MessagecentralsEndpoint extends Request {
    protected importsEndpoint: ImportsEndpoint;

    imports(id: number): ImportsEndpoint {
        return new ImportsEndpoint(this.http, this.settings, id);
    }

    proxy(id: number): ProxyEndpoint {
        return new ProxyEndpoint(this.http, this.settings, id);
    }

    collection(limit: number, offset: number): Observable<Messagecentral[]> {
        return this.get('/v1/messagecentrals', this.createSearch({
            limit: limit,
            offset: offset
        }));
    }

    create(entity: Messagecentral): Observable<Messagecentral> {
        return this.post('/v1/messagecentrals', entity);
    }

    update(entity: Messagecentral): Observable<Messagecentral> {
        return this.patch('/v1/messagecentrals/' + entity.id, entity);
    }

    remove(id: number): Observable<boolean> {
        return this.delete('/v1/messagecentrals/' + id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/messagecentrals/api.service.ts